import React from 'react'
import { Edit } from 'react-admin'
import ClubForm from './ClubForm'
import Toolbar from '../../components/FormToolbar'
import { transformData } from '../utils/helpers'

const EditTournament = (props) => {
  return (
    <Edit
      {...props}
      toolbar={<Toolbar />}
      title='Редактирование клуба'
      undoable={false}
      transform={transformData}
    >
      <ClubForm {...props} isEdit={true} />
    </Edit>
  )
}

export default EditTournament
